<section class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">{{eventCode ? 'Modifica eveniment': 'Creeaza eveniment'}}</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-md-8 mb-3 mb-md-0">

      <!-- Event contributions -->
      <section class="card border-0 mb-4">
        <div class="card-body">
          <div class="steps steps-horizontal steps-center mb-4">
            <div class="step" [ngClass]="{'active': selectedTab === tabs.DETAILS}">
              <div class="step-number" ngbTooltip="Detalii">
                <div class="step-number-inner fs-4">
                  <i class="ai-calendar"></i>
                </div>
              </div>
            </div>

            <div class="step" [ngClass]="{'active': selectedTab === tabs.IMAGE}">
              <div class="step-number" ngbTooltip="Imagine">
                <div class="step-number-inner fs-4">
                  <i class="ai-image"></i>
                </div>
              </div>
            </div>

            <div class="step" [ngClass]="{'active': selectedTab === tabs.SETTINGS}">
              <div class="step-number" ngbTooltip="Setari">
                <div class="step-number-inner fs-4">
                  <i class="ai-settings"></i>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === tabs.DETAILS">
            <form [formGroup]="form" novalidate autocomplete="off">
              <div class="row g-3 g-sm-4">

                <div class="col-sm-6">
                  <label class="form-label" for="eventTypeId">Tip eveniment</label>
                  <ng-select formControlName="eventTypeId" [ngClass]="{'is-invalid': vs.hasErrors(form, 'eventTypeId')}"
                    class="form-control" [items]="eventTypesFormatted" [closeOnSelect]="true" [searchable]="false"
                    [clearable]="false" bindLabel="text" bindValue="id" id="eventTypeId">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <img *ngIf="item.thumbnail" class="event-type-thumbnail" height="30" [src]="item.thumbnail"
                        [alt]="item.text" />
                      <span class="event-type-name ms-2">{{item.text}}</span>
                    </ng-template>
                    <!-- <ng-template ng-label-tmp let-item="item">
                      <img *ngIf="item.thumbnail" class="event-type-thumbnail h-100" [src]="item.thumbnail"
                        [alt]="item.text" />
                      <span class="event-type-name">{{item.text}}</span>
                    </ng-template> -->
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'eventTypeId')">{{vs.getError(form,
                    'eventTypeId')}}
                  </div>
                </div>

                <div class="col-sm-6">
                  <label class="form-label" for="name">Titlu</label>
                  <input formControlName="name" [ngClass]="{'is-invalid': vs.hasErrors(form, 'name')}"
                    class="form-control" type="text" placeholder="Ex: La multi ani, Alina!" id="name">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'name')">{{vs.getError(form, 'name')}}
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-check form-check-inline">
                    <input formControlName="isOnBehalf" [value]="false" class="form-check-input" type="radio"
                      id="isOnBehalfFalse">
                    <label class="form-check-label" for="isOnBehalfFalse">Pentru mine</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input formControlName="isOnBehalf" [value]="true" class="form-check-input" type="radio"
                      id="isOnBehalfTrue">
                    <label class="form-check-label" for="isOnBehalfTrue">Pentru un prieten</label>
                  </div>
                </div>

                <div class="col-sm-6" *ngIf="form.value.isOnBehalf" [@panelInOut]>
                  <label class="form-label" for="recipientName">Numele prietenului</label>
                  <input formControlName="recipientName" [ngClass]="{'is-invalid': vs.hasErrors(form, 'recipientName')}"
                    class="form-control" type="text" placeholder="" id="recipientName">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'recipientName')">{{vs.getError(form,
                    'recipientName')}}
                  </div>
                </div>

                <div class="col-sm-6" *ngIf="form.value.isOnBehalf" [@panelInOut]>
                  <label class="form-label" for="recipientEmail">Email-ul prietenului</label>
                  <input formControlName="recipientEmail"
                    [ngClass]="{'is-invalid': vs.hasErrors(form, 'recipientEmail')}" class="form-control" type="email"
                    placeholder="" id="recipientEmail">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'recipientEmail')">{{vs.getError(form,
                    'recipientEmail')}}
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label" for="description">Descriere</label>
                  <editor [init]="{
                      base_url: '/tinymce',
                      suffix: '.min',
                      height: 300,
                      menubar: false,
                      statusbar: false,
                      automatic_uploads: false,
                      paste_data_images: true,
                      theme: 'silver',
                      style_formats: styleFormats,
                      plugins:
                      'advlist autolink lists link image charmap preview anchor \
                      searchreplace visualblocks code fullscreen \
                      insertdatetime media table',
                      toolbar:
                        'undo redo | \
                        bold italic underline forecolor backcolor | \
                        styles | \
                        bullist numlist outdent indent | \
                        link image'
                      }" licenseKey="gpl" formControlName="description" [ngClass]="{'is-invalid': vs.hasErrors(form, 'description')}"
                    id="description"></editor>

                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'description')">{{vs.getError(form,
                    'description')}}
                  </div>
                </div>

                <div class="col-sm-6">
                  <label class="form-label" for="deadlineDate">Data limita</label>
                  <input formControlName="deadlineDate" ngbDatepicker #datePicker="ngbDatepicker"
                    [minDate]="{ year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }"
                    (click)="datePicker.toggle()" [ngClass]="{'is-invalid': vs.hasErrors(form, 'deadlineDate')}"
                    class="form-control" type="text" placeholder="zz/ll/aaaa" id="deadlineDate" readonly>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'deadlineDate')">{{vs.getError(form,
                    'deadlineDate')}}
                  </div>
                </div>

                <div class="col-sm-6">
                  <label class="form-label" for="targetAmount">Target</label>
                  <input formControlName="targetAmount" [ngClass]="{'is-invalid': vs.hasErrors(form, 'targetAmount')}"
                    class="form-control" type="number" inputmode="numeric" step="1" pattern="[0-9]*" gsDecimalInput
                    [decimal]="false" [min]="1" [max]="99999" id="targetAmount">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'targetAmount')">{{vs.getError(form,
                    'targetAmount')}}
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input formControlName="isPublic" [ngClass]="{'is-invalid': vs.hasErrors(form, 'isPublic')}"
                      type="checkbox" class="form-check-input" id="isPublic">
                    <label class="form-check-label" for="isPublic">Doresc ca evenimentul sa fie public</label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'isPublic')">{{vs.getError(form,
                      'isPublic')}}</div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="selectedTab === tabs.IMAGE">
            <form [formGroup]="formImage" novalidate autocomplete="off">
              <div class="row">
                <div class="col-12">
                  <gs-image-crop [editedImage]="editedImage" [originalImage]="originalImage" type="event"
                    (fileName)="onImageSelected($event)"></gs-image-crop>
                </div>
              </div>

            </form>
          </div>

          <div *ngIf="selectedTab === tabs.SETTINGS">
            <form [formGroup]="formSettings" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
              <div class="row g-3 g-sm-4">
                <div class="col-12">
                  <div class="form-check form-switch">
                    <input formControlName="hasTargetAmountHidden"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'hasTargetAmountHidden')}" type="checkbox"
                      class="form-check-input" id="hasTargetAmountHidden">
                    <label class="form-check-label" for="hasTargetAmountHidden">Ascunde suma target si total contributii
                      din pagina evenimentului</label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(formSettings, 'hasTargetAmountHidden')">
                      {{vs.getError(formSettings,
                      'hasTargetAmountHidden')}}</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input formControlName="hasContributionsHidden"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'hasContributionsHidden')}" type="checkbox"
                      class="form-check-input" id="hasContributionsHidden">
                    <label class="form-check-label" for="hasContributionsHidden">Ascunde toate contributiile</label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(formSettings, 'hasContributionsHidden')">
                      {{vs.getError(formSettings,
                      'hasContributionsHidden')}}</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input formControlName="hasCommentsHidden"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'hasCommentsHidden')}" type="checkbox"
                      class="form-check-input" id="hasCommentsHidden">
                    <label class="form-check-label" for="hasCommentsHidden">Dezactiveaza mesaje si comentarii</label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(formSettings, 'hasCommentsHidden')">
                      {{vs.getError(formSettings,
                      'hasCommentsHidden')}}</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input formControlName="hasSuggestedAmount"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'hasSuggestedAmount')}" type="checkbox"
                      class="form-check-input" id="hasSuggestedAmount">
                    <label class="form-check-label" for="hasSuggestedAmount">Sugereaza o suma pentru contributii</label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(formSettings, 'hasSuggestedAmount')">
                      {{vs.getError(formSettings,
                      'hasSuggestedAmount')}}</div>
                  </div>
                </div>

                <div *ngIf="formSettings.value.hasSuggestedAmount" [@panelInOut] class="col-sm-6">
                  <!-- <label class="form-label"
                    for="suggestedAmount">Valoare</label> -->
                  <div class="input-group">
                    <input formControlName="suggestedAmount"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'suggestedAmount')}" class="form-control"
                      type="number" inputmode="numeric" step="1" pattern="[0-9]*" gsDecimalInput [decimal]="false"
                      [min]="1" [max]="99999" id="suggestedAmount">
                    <span class="input-group-text">.00 LEI</span>
                  </div>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(formSettings, 'suggestedAmount')">
                    {{vs.getError(formSettings,
                    'suggestedAmount')}}
                  </div>
                </div>

                <div *ngIf="!eventCode" class="col-12">
                  <div class="form-check">
                    <input formControlName="hasAcceptedTerms"
                      [ngClass]="{'is-invalid': vs.hasErrors(formSettings, 'hasAcceptedTerms')}"
                      class="form-check-input" type="checkbox" id="hasAcceptedTerms">
                    <label class="form-check-label" for="hasAcceptedTerms"><span class="text-muted"> Am citit si sunt
                        de acord cu </span><a class="fw-medium" target="_blank" [routerLink]="['/termeni-si-conditii']">
                        Termenii si conditiile
                      </a>
                    </label>
                    <div *ngIf="vs.hasError(formSettings, 'hasAcceptedTerms', 'required')" class="invalid-feedback">
                      Termenii si
                      conditiile trebuie citite si acceptate.</div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>

        <div class="card-footer d-flex flex-column flex-sm-row justify-content-between">
          <button (click)="onBackClick()" class="btn btn-secondary btn-lg mb-3 mb-sm-0"
            type="button">{{backLabel}}</button>
          <button (click)="onNextClick()" class="btn btn-primary btn-lg" type="button">{{nextLabel}}</button>

        </div>
      </section>
    </div>

    <!-- Product details-->
    <div class="col-md-4">

      <div class="card border-0 mb-4">
        <div class="card-body">
          <h4 class="card-title"><i class="ai-bulb text-primary lead pe-1 me-2"></i>Informatii suplimentare</h4>

          <ng-container *ngIf="selectedTab !== tabs.SETTINGS">
            <div ngbAccordion [closeOthers]="true">
              <div ngbAccordionItem [collapsed]="false">
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Despre titlu
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      Titlul este primul lucru pe care il vad invitatii cand acceseaza
                      evenimentul tau. Alege unul
                      reprezentativ.
                    </ng-template></div>
                </div>
              </div>
              <div ngbAccordionItem>
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Despre
                    descriere
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      In descriere, lasa invitatilor un mesaj in care le povestesti despre momentul special pe care il
                      sarbatoriti sau despre fapta buna pe care vrei sa o faci in societate (eveniment caritabil).
                    </ng-template></div>
                </div>
              </div>
              <div ngbAccordionItem>
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Despre data limita & target
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      Stabileste o data limita pana la care invitatii pot contribui la cadoul de grup sau te pot ajuta
                      sa
                      faci o fapta buna in societate. Evenimentul se va incheia in ziua respectiva la ora 23:59.
                      Targetul
                      reprezinta suma pe care iti propui sa o strangi. Daca nu o vei atinge, nu-i nimic, primesti banii
                      care s-au strans pana la data limita sau ai posibilitatea sa prelungesti evenimentul (inainte de
                      expirarea acestuia).
                    </ng-template></div>
                </div>
              </div>
              <div ngbAccordionItem>
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Despre
                    confidentialitate
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      In mod implicit, evenimentul tau este privat si poate fi accesat
                      doar de catre persoanele carora le
                      vei trimite link-ul. Daca vei alege sa faci evenimentul public, acesta va aparea in lista de
                      evenimente publice de pe <a href="https://giftshare.ro">GiftShare.ro</a>. Este indicat ca
                      evenimentele
                      de caritate sa fie publice.
                    </ng-template></div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="selectedTab === tabs.SETTINGS">
            <div ngbAccordion [closeOthers]="true">
              <div ngbAccordionItem [collapsed]="false">
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Despre setari
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      Inainte de a da vestea, alege daca vrei ca familia si prietenii sa
                      vada detalii precum suma
                      pe care iti propui sa o strangi pentru cadou sau cine a mai contribuit la cadoul tau
                      si cu cat. Poti chiar sa le sugerezi o suma cu care sa contribuie fiecare si sa decizi
                      daca permiti mesaje si comentarii pe pagina de eveniment.
                    </ng-template></div>
                </div>
              </div>
              <div ngbAccordionItem>
                <div ngbAccordionHeader>
                  <button ngbAccordionButton>
                    Ultimul pas...
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="fs-sm"><ng-template>
                      Raspandeste vestea cea buna! Trimite prietenilor si familiei linkul catre evenimentul tau prin
                      mail,
                      mesaje prin orice serviciu de mesagerie folosesti sau postari publice pe retelele sociale.
                    </ng-template></div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>


    </div>
  </div>
</section>
